import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../data/content";
import { SectionTitle } from "./SectionTitle";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist px-4 py-16 sm:px-6 sm:py-24" data-id="element-47" data-mp="1gd7h4a4s9d6j">
      <SectionTitle tone="light" title={<>Questions <span className="text-golddark" data-id="element-49" data-mp="2e0prfpe3encn">fréquentes</span></>} data-id="element-48" data-mp="1gauqz9ovfwie" />
      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-50" data-mp="291d4l4n81ga2">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl border border-forest/10 bg-white shadow-[0_4px_16px_rgba(9,40,29,0.05)]" data-id="element-51" data-mp="240yulh227w9e" data-mpi={i}>
              <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-semibold text-forest sm:px-6 sm:py-5 sm:text-lg" data-id="element-52" data-mp="1z5jiatjpa8f3">
                {f.q}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-golddark transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden data-id="element-53" data-mp="uh0w8bmxuro5" />
              </button>
              <AnimatePresence initial={false} data-id="element-54" data-mp="khtjnqo13123">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-55" data-mp="6qwte6hkqvy7">
                    <p className="px-5 pb-5 text-forest/75 sm:px-6" data-id="element-56" data-mp="1rtyhevb663y">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}